module.exports = __webpack_public_path__ + "img/wave-2.e40fffc2.svg";